export class ScenarioError {
  mnemonic: string;
  scenario_id: number;
  balance: any;
  property: Property;
  errors: ErrorsView[];
}

export class ErrorsView {
  row: number;
  column: number;
  message: string;
}

export class Property {
  mnemonic: string;
  period: number;
  error_code: string;
  othermnemonic: string;
}
